export default {
  SET_PARENT_CAMPAIGN: "GIVING_FORM_SET_PARENT_CAMPAIGN",
};
